import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { deliveryDatesClient } from "@core/clients";
import { SHIPPING_DELIVERY_DATES_INTERVALS_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";
import { DeliveryInterval, ISODate } from "@core/types";

interface DeliveryIntervalsQueryAttrs {
  shippingMethodId?: string;
  date?: ISODate;
}

const useGetDeliveryIntervalsQuery = (
  { shippingMethodId, date }: DeliveryIntervalsQueryAttrs = {},
  options: UseQueryOptions<DeliveryInterval[]> = {},
) => {
  return useQuery<DeliveryInterval[]>(
    ["delivery-intervals", date, shippingMethodId ?? "no_shipping_method"],
    async () => {
      if (deliveryDatesClient) {
        if (!date) return [];
        const data = await deliveryDatesClient.getDeliveryIntervals(shippingMethodId, date);
        return data;
      }

      throw new Error("deliveryDatesClient not implemented");
    },
    {
      cacheTime: SHIPPING_DELIVERY_DATES_INTERVALS_CACHE_EXPIRE_TIME_MS,
      staleTime: SHIPPING_DELIVERY_DATES_INTERVALS_CACHE_EXPIRE_TIME_MS,
      refetchInterval: SHIPPING_DELIVERY_DATES_INTERVALS_CACHE_EXPIRE_TIME_MS,
      refetchIntervalInBackground: true,
      retry: 2,
      ...options,
    },
  );
};

export default useGetDeliveryIntervalsQuery;
